import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { FormControl } from 'foundations-components/transitional/components/FormControl';
import { Select } from 'foundations-components/transitional/components/Select';
import { Text } from 'foundations-components/components/Text';
import { View } from 'foundations-components/components/View';
import { FormatValues } from 'ExportDialog/Constants';
import { ExportLimits, Formats } from '../../Constants';
import unescapedText from 'I18n/utils/unescapedText';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
function createValueExtractor(onChangeCallback) {
  return event => {
    onChangeCallback(event.target.value);
  };
}
const FormatField = ({
  onChange,
  value
}) => /*#__PURE__*/_jsxs(_Fragment, {
  children: [/*#__PURE__*/_jsx(FormControl, {
    label: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "exportDialog.fields.formatLabel"
    }),
    children: /*#__PURE__*/_jsx(Select, {
      value: value,
      onChange: createValueExtractor(onChange),
      options: FormatValues.map(format => ({
        text: unescapedText(`exportDialog.formats.${format}`),
        value: format
      }))
    })
  }), /*#__PURE__*/_jsx(View, {
    marginBlockStart: "300",
    marginBlockEnd: "600",
    children: /*#__PURE__*/_jsxs(Text, {
      as: "small",
      children: [value === Formats.XLS && /*#__PURE__*/_jsx(FormattedMessage, {
        message: "exportDialog.fields.xlsLimit",
        options: {
          limit: I18n.formatNumber(ExportLimits.XLS)
        }
      }), value === Formats.XLSX && /*#__PURE__*/_jsx(FormattedMessage, {
        message: "exportDialog.fields.xlsxLimit",
        options: {
          limit: I18n.abbreviateNumber(ExportLimits.XLSX, {
            type: 'long'
          })
        }
      })]
    })
  })]
});
export default FormatField;